import { render } from "./ChangePassword.vue?vue&type=template&id=bccd3ad0&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "@/assets/css/layout_login.css?vue&type=style&index=0&id=bccd3ad0&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccd3ad0"]])

export default __exports__